import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'tmst-info-box',
  templateUrl: './info-box.component.html',
  styleUrl: './info-box.component.scss',
  standalone: false
})
export class InfoBoxComponent {
  @Input() translateKey: string;
  @Input() translateKey4HelpBtntxt: string;
  @Input() translateKey4HelpTxt: string;
  @Input() isAlertBox: boolean;
  @Input() allowDialogBox: boolean;

  constructor(public readonly dialog: MatDialog) {}
}
